<template>
  <b-container class="mt20">
    <b-row>
      <b-col lg="3" xl="3" sm="12" md="2">
        <b-breadcrumb :items="bread"></b-breadcrumb>
      </b-col>
      <!-- <b-col lg="2" xl="2" sm="3" md="2">
        <b-form-select v-model="selectedTheme" :options="tableTheme" placeholder="请选择表主题"></b-form-select>
      </b-col>-->
      <b-col lg="3" xl="3" sm="3" md="4">
        航次执行年份：
        <b-form-select
          style="width:120px"
          v-model="reqBody.cruiseYear"
          :options="years"
          placeholder="请选择年份"
          @change="requestVoyage(true)"
        ></b-form-select>
      </b-col>
      <b-col lg="2" xl="2" sm="3" md="2">
        <b-form-select v-model="selectFields" :options="fields" placeholder="请选择搜索条件"></b-form-select>
      </b-col>
      <b-col lg="4" xl="4" sm="6" md="4">
        <b-input-group style="float: right">
          <b-form-input placeholder="输入关键字搜索" v-model="keyword"></b-form-input>
          <b-input-group-append>
            <b-button variant="info" @click="requestVoyage(true)">搜索</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>

    <b-table-simple hover small caption-top responsive class="mt10" bordered>
      <b-thead style="line-height: 48px;">
        <b-tr>
          <b-th>航次执行年份</b-th>
          <b-th>序号</b-th>
          <b-th>航次名称</b-th>
          <b-th>航次编号</b-th>
        </b-tr>
      </b-thead>
      <b-tbody style="line-height: 32px;">
        <b-tr v-for="(item, index) in items" :key="index" @click="onRowClicked(item)">
          <!-- size 指每一年的航次数量 -->
          <b-th :rowspan="item.size" v-if="item.size > 0">{{item.cruiseYear}}</b-th>
          <b-td>{{item.sequenceNumber}}</b-td>
          <b-td>{{item.cruiseName}}</b-td>
          <b-td>{{item.cruiseId}}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <link-component></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';

export default {
  components: {
    LinkComponent
  },
  name: 'voyage',
  props: {},
  data() {
    return {
      keyword: '',
      bread: [
        {
          text: '首页',
          href: '/index'
        },
        {
          text: '共享航次'
        }
      ],
      // selectedTheme: 1,
      // tableTheme: [
      //   {
      //     value: '1',
      //     text: '白色主题'
      //   },
      //   {
      //     value: '2',
      //     text: '黑色主题'
      //   }
      // ],
      items: [],
      reqBody: {
        page: 1,
        pageSize: 200,
        cruiseId: '',
        cruiseName: '',
        cruiseYear: null
      },
      years: [
        {
          value: null,
          text: '全部年份'
        }, { value: '2025', text: '2025' },
        {
          value: '2024',
          text: '2024'
        },
        {
          value: '2023',
          text: '2023'
        },
        {
          value: '2022',
          text: '2022'
        },
         {
          value: '2021',
          text: '2021'
        },
        {
          value: '2020',
          text: '2020'
        },
        {
          value: '2019',
          text: '2019'
        },
        {
          value: '2018',
          text: '2018'
        },
        {
          value: '2017',
          text: '2017'
        },
        {
          value: '2016',
          text: '2016'
        },
        {
          value: '2015',
          text: '2015'
        },
        {
          value: '2014',
          text: '2014'
        },
        {
          value: '2013',
          text: '2013'
        },
        {
          value: '2012',
          text: '2012'
        },
        {
          value: '2011',
          text: '2011'
        },
        {
          value: '2010',
          text: '2010'
        }
      ],
      selectFields: null,
      fields: [
        {
          value: null,
          text: '请选择搜索条件'
        },
        {
          value: '1',
          text: '航次编号'
        },
        {
          value: '2',
          text: '航次名称'
        },
        {
          value: '3',
          text: '航次目标'
        },
        {
          value: '4',
          text: '航次区域'
        },
        {
          value: '5',
          text: '航次时间'
        },
        {
          value: '6',
          text: '航次内容'
        }
      ]
    };
  },
  mounted() {
    this.requestVoyage();
  },
  methods: {
    requestVoyage(isButtonClicked) {
      if (isButtonClicked) {
        this.reqBody.cruiseId = null;
        this.reqBody.cruiseName = null;
        this.reqBody.cruiseAim = null;
        this.reqBody.cruiseArea = null;
        this.reqBody.cruiseTime = null;
        this.reqBody.cruiseContent = null;
        this.reqBody.page = 1;
        switch (this.selectFields) {
          case '1':
            this.reqBody.cruiseId = this.keyword;
            break;
          case '2':
            this.reqBody.cruiseName = this.keyword;
            break;
          case '3':
            this.reqBody.cruiseAim = this.keyword;
            break;
          case '4':
            this.reqBody.cruiseArea = this.keyword;
            break;
          case '5':
            this.reqBody.cruiseTime = this.keyword;
            break;
          case '6':
            this.reqBody.cruiseContent = this.keyword;
        }
      }
      axiosServer({
        url: urls.voyage,
        params: this.reqBody //将参数设置为变量reqBody
      }).then(resp => {
        this.items = resp.data.page.list;
        // this.items.reverse(); // 反转数据
        let size = 0; //每年有多少个航次
        let preItem = null; //循环的前一个item
        let firstStartYearCruise = null; //当年的第一个航次
        let isJustOneYearData = true; //是否只有1年的数据

        //先排序
        this.items.sort(this.compare);

        // console.log(this.items);

        this.items.forEach(item => {
          if (!preItem) {
            firstStartYearCruise = item;
            size++;
          } else {
            if (preItem.cruiseYear == item.cruiseYear) {
              size++;
            } else {
              isJustOneYearData = false;
              firstStartYearCruise.size = size;
              size = 1;
              firstStartYearCruise = item;
            }
          }
          preItem = item;
        });

        if (isJustOneYearData) {
          this.items[0].size = size;
        } else {
          //最后一个设置一下
          this.items[this.items.length - size].size = size;
        }
      });
    },

    compare(a, b) {
      if (a.cruiseYear > b.cruiseYear) {
        return -1; //sort()中参数大于0，交换a b顺序，升序排列
      } else {
        return 0; //sort()中参数小于0，a b顺序不变，升序排列
      }
    },
    onRowClicked(item) {
      // this.$router.push({ name: 'voyageDetail', query: { id: item.id } });
    }
  }
};
</script>

<style scoped>
</style>
